export const IternalTheme = {
  palette: {
    common: {
      black: '#222',
      dark: '#222',
      slate: '#444',
      slate2: '#555',
      slate3: '#666',
      slate4: '#777',
      slate5: '#888',
      mist: '#aaa',
      white: '#fff',
    },
    type: 'light',
    // Calculate with this rough guideline:
    // light: +0,-25,+10
    // main:  +0, +0,+0
    // dark:  +0,+5,-10
    primary: {
      light6: 'hsl(178, 63%, 96%)',
      light5: 'hsl(178, 63%, 86%)',
      light4: 'hsl(178, 63%, 76%)',
      light3: 'hsl(178, 63%, 66%)',
      light2: 'hsl(178, 63%, 56%)',
      light: 'hsl(178, 63%, 46%)',
      main: 'hsl(178, 88%, 36%)',
      dark: 'hsl(178, 93%, 26%)',
      dark2: 'hsl(178, 93%, 16%)',
      dark3: 'hsl(178, 93%, 10%)',
      dark4: 'hsl(178, 93%, 5%)',
      contrastText: '#ffffff',
    },
    // primary: {
    //   light6: 'hsl(222, 55%, 95%)',
    //   light5: 'hsl(222, 55%, 85%)',
    //   light4: 'hsl(222, 55%, 75%)',
    //   light3: 'hsl(222, 55%, 65%)',
    //   light2: 'hsl(222, 55%, 55%)',
    //   light: 'hsl(222, 55%, 45%)',
    //   main: 'hsl(222, 80%, 35%)',
    //   dark: 'hsl(222, 85%, 23%)',
    //   dark2: 'hsl(222, 85%, 13%)',
    //   dark3: 'hsl(222, 85%, 5%)',
    //   contrastText: '#ffffff',
    // },
    secondary: {
      light5: 'hsl(43, 85%, 95%)',
      light4: 'hsl(43, 85%, 90%)',
      light3: 'hsl(43, 85%, 80%)',
      light2: 'hsl(43, 85%, 70%)',
      light: 'hsl(43, 85%, 60%)',
      main: 'hsl(43, 85%, 50%)',
      dark: 'hsl(43, 90%, 40%)',
      dark1: 'hsl(43, 90%, 30%)',
      dark2: 'hsl(43, 90%, 20%)',
      dark3: 'hsl(43, 90%, 10%)',
      dark4: 'hsl(43, 90%, 5%)',
      contrastText: '#0a2156',
    },
    error: {
      light6: 'hsl(0, 67%, 93%)',
      light5: 'hsl(0, 67%, 83%)',
      light4: 'hsl(0, 67%, 73%)',
      light3: 'hsl(0, 67%, 63%)',
      light2: 'hsl(0, 67%, 53%)',
      light: 'hsl(0, 67%, 43%)',
      main: 'hsl(0, 92%, 33%)',
      dark: 'hsl(0, 97%, 23%)',
      dark2: 'hsl(0, 97%, 13%)',
      dark3: 'hsl(0, 97%, 5%)',
      contrastText: '#ffffff',
    },
    warning: {
      light5: 'hsl(24, 59%, 95%)',
      light4: 'hsl(24, 59%, 88%)',
      light3: 'hsl(24, 59%, 78%)',
      light2: 'hsl(24, 59%, 68%)',
      light: 'hsl(24, 59%, 58%)',
      main: 'hsl(24, 84%, 48%)',
      dark: 'hsl(24, 89%, 38%)',
      dark2: 'hsl(24, 89%, 28%)',
      dark3: 'hsl(24, 89%, 18%)',
      dark4: 'hsl(24, 89%, 10%)',
      dark5: 'hsl(24, 89%, 5%)',
      contrastText: '#000000',
    },
    info: {
      light6: 'hsl(200, 42%, 94%)',
      light5: 'hsl(200, 42%, 84%)',
      light4: 'hsl(200, 42%, 74%)',
      light3: 'hsl(200, 42%, 64%)',
      light2: 'hsl(200, 42%, 54%)',
      light: 'hsl(200, 42%, 44%)',
      main: 'hsl(200, 67%, 34%)',
      dark: 'hsl(200, 72%, 24%)',
      dark2: 'hsl(200, 72%, 14%)',
      dark3: 'hsl(200, 72%, 5%)',
      contrastText: '#000000',
    },
    success: {
      light6: 'hsl(178, 63%, 96%)',
      light5: 'hsl(178, 63%, 86%)',
      light4: 'hsl(178, 63%, 76%)',
      light3: 'hsl(178, 63%, 66%)',
      light2: 'hsl(178, 63%, 56%)',
      light: 'hsl(178, 63%, 46%)',
      main: 'hsl(178, 88%, 36%)',
      dark: 'hsl(178, 93%, 26%)',
      dark2: 'hsl(178, 93%, 16%)',
      dark3: 'hsl(178, 93%, 10%)',
      dark4: 'hsl(178, 93%, 5%)',
      contrastText: '#ffffff',
    },
    groups: {
      light6: 'hsl(200, 52%, 94%)',
      light5: 'hsl(200, 52%, 84%)',
      light4: 'hsl(200, 52%, 74%)',
      light3: 'hsl(200, 52%, 64%)',
      light2: 'hsl(200, 52%, 54%)',
      light: 'hsl(200, 52%, 44%)',
      main: 'hsl(200, 67%, 34%)',
      dark: 'hsl(200, 72%, 24%)',
      dark2: 'hsl(200, 72%, 14%)',
      dark3: 'hsl(200, 72%, 8%)',
      dark4: 'hsl(200, 72%, 3%)',
      contrastText: '#ffffff',
    },
  },
  shadows: [
    'none',
    '0px 1px 18px 0px rgba(0,0,0,0.08)',
    '0px 2px 16px 0px rgba(0,0,0,0.08)',
    '0px 0px 3px 4px rgba(0,0,0,0.09)',
    '0px 3px 16px 0px rgba(0,0,0,0.08)',
    '0px 4px 18px 0px rgba(0,0,0,0.08)',
    '0px 4px 20px 0px rgba(0,0,0,0.08)',
    '0px 5px 22px 0px rgba(0,0,0,0.083)',
    '0px 5px 24px 0px rgba(0,0,0,0.083)',
    '0px 5px 26px 0px rgba(0,0,0,0.083)',
    '0px 6px 28px 0px rgba(0,0,0,0.083)',
    '0px 6px 30px 0px rgba(0,0,0,0.083)',
    '0px 6px 32px 0px rgba(0,0,0,0.085)',
    '0px 7px 34px 0px rgba(0,0,0,0.085)',
    '0px 7px 36px 0px rgba(0,0,0,0.085)',
    '0px 8px 38px 0px rgba(0,0,0,0.085)',
    '0px 8px 40px 0px rgba(0,0,0,0.085)',
    '0px 8px 42px 0px rgba(0,0,0,0.09)',
    '0px 9px 44px 0px rgba(0,0,0,0.09)',
    '0px 9px 46px 0px rgba(0,0,0,0.09)',
    '0px 9px 46px 0px rgba(0,0,0,0.09)',
    '0px 10px 46px 0px rgba(0,0,0,0.1)',
    '0px 10px 48px 0px rgba(0,0,0,0.1)',
    '0px 10px 50px 0px rgba(0,0,0,0.1)',
    '0px 10px 50px 0px rgba(0,0,0,0.1)',
    '0px 10px 52px 0px rgba(0,0,0,0.1)',
    '0px 11px 54px 0px rgba(0,0,0,0.1)',
    '0px 11px 56px 0px rgba(0,0,0,0.1)',
    '0px 11px 58px 0px rgba(0,0,0,0.1)',
    '0px 11px 60px 0px rgba(0,0,0,0.1)',
    '0px 11px 62px 0px rgba(0,0,0,0.1)',
  ],
  typography: {
    htmlFontSize: 16,
    fontSize: 15,
    h1: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontWeight: 500,
      // fontSize: 44,
    },
    h2: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontWeight: 600,
      // fontSize: 36,
    },
    h3: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontWeight: 400,
      // fontSize: 28,
    },
    h4: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontWeight: 400,
      // fontSize: 24,
    },
    h5: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontWeight: 400,
      // fontSize: 22,
    },
    h6: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontWeight: 400,
      // fontSize: 20,
    },
    subtitle1: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
    },
    subtitle2: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
    },
    body1: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
    },
    body2: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
    },
    button: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      letterSpacing: 0.25,
      textTransform: 'capitalize',
    },
    caption: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
    },
    overline: {
      fontFamily: `'Maven Pro', 'Helvetica', 'Arial', sans-serif`,
      fontSize: 14,
      letterSpacing: 1.5,
    },
  },
  shape: {
    borderRadius: 7,
  },
};

export const defaultShadows = {
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
    '0px 11px 16px -7px rgba(0,0,0,0.2),0px 24px 40px 3px rgba(0,0,0,0.14),0px 9px 46px 10px rgba(0,0,0,0.12)',
    '0px 11px 17px -7px rgba(0,0,0,0.2),0px 24px 42px 3px rgba(0,0,0,0.14),0px 9px 46px 12px rgba(0,0,0,0.12)',
  ],
};
